import React from 'react';
import { useNavigate } from 'react-router-dom';
import './level_1.css';
import RoomPuzzleLevel from './room_puzzle_level';
import { LEVEL_1_PUZZLE } from './room_puzzle_data';
import gameplayBackground from '../assets/gamescreen.png';
import instructions from '../assets/instructions.png';
import level1WinVideo from '../assets/level1win.mp4';
import { getLevelTime } from './level_time';

const Level1 = (props) => {
  const navigate = useNavigate();

  return (
    <RoomPuzzleLevel
      basePath="/level_1"
      backgroundImage={gameplayBackground}
      instructionsBackground={instructions}
      instructionsTitle="Instructions"
      instructionsText={[
        'Click on the wall to activate the alabaster staff and reveal the hidden hieroglyphics',
        'Solve the riddle to open the door',
        'Only the right order will open the door. The wrong order will make you lose.'
      ]}
      levelTime={getLevelTime(1)}
      moneyCount={props.moneyCount}
      onComplete={() => {
        props.unlockLevel2();
        navigate('/levels');
      }}
      puzzle={LEVEL_1_PUZZLE}
      setMoneyCount={props.setMoneyCount}
      setShowSettings={props.setShowSettings}
      showSettings={props.showSettings}
      winVideoSrc={level1WinVideo}
    />
  );
};

export default Level1;
